import axios from 'axios';
import Forms from '../common/forms';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

export default class NewsletterForm {

    constructor() {
        this.section = document.querySelector('.layout-newsletter')
        
        this.form = document.querySelector('#formNewsletter');
        this.formFields = this.form.querySelectorAll('input, select, textarea')
		
        this.successMessage = this.section.querySelector('.layout-newsletter .success-form')
		this.errorMessage = this.section.querySelector('.layout-newsletter .error-form')
        this.errorSubmitMessage = this.section.querySelector('.layout-newsletter .error-submit-form')
        
        this.btnSubmit = this.form.querySelector('#btnSendNewsletter');
        
        this.hiddenFields = this.section.querySelector('.newsletter');
        this.btnCloseNewsletter = this.section.querySelector('.btn-close-newsletter');

        new Forms();

        this.ready();
        this.bindEvents();
        this.initRecaptcha();
    }

    ready() {
        
        new Bouncer(`#formNewsletter`, {
            ...Forms.config(),
            messages: Forms.messages(),
        });


        this.form.addEventListener('bouncerShowError', () => {
            this.errorMessage.classList.remove('hidden')
        }, false);
        
        this.form.addEventListener('bouncerFormInvalid', () => {
            Forms.activeErros(this.form);
        }, false);

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendForm(event.target);
                }
            },
            false
        );
    }

    initRecaptcha() {
        this.formFields.forEach(field => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    window.loadRecaptchaV3();
                }
            })
        })
    }

    bindEvents() {

        this.form.querySelector('input[name="email"]').addEventListener('focus', () => {
            this.hiddenFields.classList.add('is-open');
        });

        this.btnCloseNewsletter.addEventListener('click', () => {
            this.hiddenFields.classList.remove('is-open');
        })

    }

    sendForm(form) {
        reloadCaptcha('contact', 'g-recaptcha-response', () => {
            this.errorSubmitMessage.classList.add('hidden');
            this.successMessage.classList.add('hidden');
            this.errorMessage.classList.add('hidden');

            this.btnSubmit.disabled = true;
            this.btnSubmit.classList.add('loading');

            const rawFormData = new FormData(form);

            rawFormData.set('age', form.querySelector('#fl_age').checked ? 1 : 0);
            rawFormData.set('data', form.querySelector('#fl_privacy').checked ? 1 : 0);

            const maskedPlaceholders = ['__/__/____', '(__) ____-____', '____-__'];

            const filteredFormData = new FormData();
            for (let [key, value] of rawFormData.entries()) {
                if (typeof value === 'string'
                    ? value.trim() !== '' && !maskedPlaceholders.includes(value)
                    : true) {
                    filteredFormData.append(key, value);
                }
            }

            const urlForm = form.getAttribute('data-action');

            axios.post(urlForm, filteredFormData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then((response) => {
                const { success, message } = response.data.original; // pega o original

                if (success) {
                    form.reset();
                    this.successMessage.textContent = message;
                    this.successMessage.classList.remove('hidden');

                    setTimeout(() => {
                        this.successMessage.classList.add('hidden');
                    }, 5000);
                } else {
                    this.errorSubmitMessage.textContent = message || 'Erro ao enviar formulário.';
                    this.errorSubmitMessage.classList.remove('hidden');
                }
            })
            .catch(() => {
                this.errorSubmitMessage.textContent = 'Erro ao enviar formulário.';
                this.errorSubmitMessage.classList.remove('hidden');
            })
            .finally(() => {
                this.btnSubmit.disabled = false;
                this.btnSubmit.classList.remove('loading');
            });
        });
    }



}

if(document.querySelector('.layout-newsletter')) {
    new NewsletterForm()
}